module.exports = __webpack_public_path__ + "static/media/instructor-onboarding-image24.02d78b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/instructor-onboarding-image24.png
// module id = 2646
// module chunks = 0